import React, { useState, useEffect, useContext, useMemo } from 'react';
import {
  Widget,
  usePromise,
  CrudContext,
  MasterDetailForm,
  FormSubmitButton,
  FormatText,
  FormTextArea,
  FormSwitch,
  Button,
  InlineEditTable,
  FormInput,
  FormDatePicker,
  FormNumber,
  ColumnType,
  notification,
  FormSelect,
  Table,
  useRouter,
} from '@digital/ui';
import {
  Aditivo,
  getAllAditivosSgcByContratoId,
  getInformacaoAditivo,
  InfoAditivo,
  updateAditivoInfo,
  updateAditivo,
  insertAditivo,
  StatusAditivo,
  getAllStatusAditivoOptions,
} from '@app/api/contrato/aditivosContrato';
import { Collapse, Icon } from 'antd';
import * as Yup from 'yup';
import { hasPermission } from '@app/helpers/permissions';
import { currencyFormat } from '@app/helpers/numbers';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CurrencyInput from '@app/components/CurrencyInput';

import AditivosArquivos from './AditivosArquivos';
import { iniciarProcessoEncerramento } from '@app/api/contrato/encerramento';

const { Panel } = Collapse;

const AbaAditivos = () => {

  const [aditivos, setAditivos] = useState<Aditivo[]>([]);
  const [statusAditivo] = usePromise(getAllStatusAditivoOptions, [], [] as StatusAditivo[]);
  const { history } = useRouter();

  const handleUpdate = (values: any) => { // Todos os campos de update são obrigatórios;
    let data = {
      id: values.id,
      ordem: values.ordem,
      tipoAditivo: values.tipoAditivo,
      dataTermino: values.dataTermino,
      valorContrato: values.valor,
      sgc: values.sgc,
      pendenciaArquivo: values.pendenciaArquivo,
      pendenciaAvaliacao: values.pendenciaAvaliacao,
      statusAditivoId: values.statusAditivoId,
    };
    return updateAditivo(data).then(
      (data) => {
        if (data.saldoContratoAtualizado === true) {
          notification.info('Valor e Saldo do contrato atualizados.');
        }
        if (data.dataTerminoContratoAtualizado === true) {
          notification.info('Data do término do contrato atualizada.');
        }
        atualizarTela();
      }
    );
  };

  const handleInsertAditivo = () => {
    return insertAditivo(selectedItem.id).then(
      () => atualizarTela()
    );
  };

  const columns = () => {
    if (hasPermission(['CONTRATO_ADITIVO_EDITAR'])) {
      return [
        {
          title: 'Nº Totvs',
          dataIndex: 'numero',
          width: '5%'
        },
        {
          title: 'Número',
          dataIndex: 'ordem',
          width: '5%',
          renderEdit: () => {
            return (
              <FormNumber
                name='ordem'
                required
              />
            );
          }
          render: (text, record) => {
            if (record.ordem === 0) return null;
            else return record.ordem;
          }
        },
        {
          title: 'Tipo',
          dataIndex: 'tipoAditivo',
          width: '30%',
          renderEdit: () => {
            return (
              <FormInput
                name='tipoAditivo'
                required
              />
            );
          }
        },
        {
          title: 'Data de Término',
          dataIndex: 'dataTermino',
          width: '15%',
          type: ColumnType.Date,
          renderEdit: (text, record, index) => {
            if (record.editavel === true) {
              return <FormDatePicker name="dataTermino" format="DD/MM/YYYY" required />;
            } else {
              return <FormDatePicker name="dataTermino" format="DD/MM/YYYY" disabled />;
            }
          },
        },
        {
          title: 'Valor do Aditivo',
          dataIndex: 'valorDiferenca',
          width: '15%',
          render: currencyFormat,
        },
        {
          title: 'Valor do Contrato',
          dataIndex: 'valor',
          width: '15%',
          renderEdit: (text, record, index) => {
            if (record.editavel) {
              return <CurrencyInput name="valor" />;
            }
            return <CurrencyInput name="valor" disabled />;

          },
          render: (text, record) => {
            return record.valorFormatado;
          },
        },
        {
          title: 'Status',
          dataIndex: 'statusAditivoId',
          width: '15%',
          options: statusAditivo,
          renderEdit: (text, record: Aditivo) => {
            return <FormSelect
              name="statusAditivoId"
              options={statusAditivo}
              required
            />;
          }
        },
        {
          title: 'Pendência de Arquivos',
          dataIndex: 'pendenciaArquivo',
          width: '5%',
          type: ColumnType.Switch,
          renderEdit: (text, record: Aditivo) => {
            return <FormSwitch
              name="pendenciaArquivo"
              disabled={!hasPermission(['CONTRATO_ADITIVO_INDICAR_PENDENCIA'])}
            />;
          }
        },
        {
          title: 'Pendente Avaliação',
          dataIndex: 'pendenciaAvaliacao',
          width: '5%',
          type: ColumnType.Switch,
          renderEdit: (text, record: Aditivo) => {
            return <FormSwitch
              name="pendenciaAvaliacao"
              disabled={!hasPermission(['CONTRATO_ADITIVO_INDICAR_PENDENCIA'])}
            />;
          },
        },
      ];
    } else {
      return [
        {
          title: 'Número',
          dataIndex: 'ordem',
          width: '5%',
        },
        {
          title: 'Tipo',
          dataIndex: 'tipoAditivo',
          width: '40%',
        },
        {
          title: 'Data de Término',
          dataIndex: 'dataTermino',
          width: '15%',
          type: ColumnType.Date,
        },
        {
          title: 'Valor do Aditivo',
          dataIndex: 'valorDiferenca',
          width: '20%',
          render: currencyFormat,
        },
        {
          title: 'Valor do Contrato',
          dataIndex: 'valor',
          width: '20%',
          render: (text, record) => {
            return record.valorFormatado;
          },
        }
      ];
    }
  };



  const { selectedItem } = useContext(CrudContext);
  const [carregarAditvos, setCarregarAditivos] = useState(true);
  const [pendenciaAditivo, setPendenciaAditivo] = useState<boolean>();

  const atualizarTela = () => {
    setCarregarAditivos(true);
    setCarregarAditivos(false);

    setAtualizarGridAnexoAditivo(true);
    setAtualizarGridAnexoAditivo(false);
  };

  const [atualizarGridAnexoAditivo, setAtualizarGridAnexoAditivo] = useState(false);

  useMemo(async () => {
    if (selectedItem) {
      const result = await getAllAditivosSgcByContratoId(selectedItem.id);
      if (result) {
        setAditivos(result);
      }
    }
  }, [carregarAditvos]);

  const [aditivoInfo] = usePromise(
    () => (selectedItem ? getInformacaoAditivo(selectedItem.id) : Promise.resolve(undefined)),
    [selectedItem],
    [] as InfoAditivo,
  );

  useEffect(() => {
    setPendenciaAditivo(aditivoInfo.pendenciaAditivo);
  }, [aditivoInfo]);


  const handleUpdateAditivoInfo = (values: InfoAditivo) => {
    values.pendenciaAditivo = pendenciaAditivo;
    updateAditivoInfo(values).then((result:any) => {
      if(result.valid){
        var urlAtual = window.location.href;
        const lastSlashIndex = urlAtual.lastIndexOf('/');
        urlAtual = urlAtual.substring(0, lastSlashIndex);

        history.push(`${urlAtual}/encerramento`);
      }
    });
  };

  return (
    <>
      <Collapse bordered={false} 
       expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="infoAditivo" header="Pendência de Aditivo" style={{ border: 0 }}>
          <MasterDetailForm
            onSubmit={handleUpdateAditivoInfo}
            initialValues={aditivoInfo}
            validationSchema={Yup.object().shape({
              dadosGerais_ObjetoResumido: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
              pendenciaAditivoDescricao: Yup.string().required('Campo Obrigatório')
                .min(1, 'A descrição deve ter no mínimo 5 caracteres.'),
            })}>
            <Widget
              actions={[
                hasPermission(['CONTRATO_ADITIVO_EDITAR']) && (
                  <Button type="link" onClick={() => handleInsertAditivo()}>
                    CADASTRAR ADITIVO SGC
                  </Button>
                ),
                hasPermission(['CONTRATO_ADITIVO_INDICAR_PENDENCIA']) && (
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <FormSwitch
                onClick={value => {
                  setPendenciaAditivo(false);
                }}
                label="Pendência de Aditivo?"
                name="pendenciaAditivo"
                span={3}
                checked={pendenciaAditivo}
              />

              <FormSwitch
                label="Contrato não será aditado"
                name="contratoNaoSeraAditado"
                span={3}
              />


              <FormTextArea
                disabled={pendenciaAditivo}
                required={!pendenciaAditivo}
                label="Observações"
                name="pendenciaAditivoDescricao"
                rows={6}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>


      <Widget title="Aditivos do contrato">
        <PerfectScrollbar>
          {
            hasPermission(['CONTRATO_ADITIVO_EDITAR']) ?
              (
                < InlineEditTable
                  columns={columns()} dataSource={aditivos} pagination={false} key={"id"}
                  updateItem={handleUpdate}
                  disablenotification={false}
                />
              ) : (
                < Table
                  columns={columns()} dataSource={aditivos} pagination={false} key={"id"}
                />
              )
          }
        </PerfectScrollbar>
      </Widget>

      {selectedItem && aditivos ? (
        <Widget title="Anexos dos aditivos">
          <AditivosArquivos
            contratoId={selectedItem.id}
            atualizarGridAnexoAditivo={atualizarGridAnexoAditivo}
            onUpdatePage={atualizarTela}
          />
        </Widget>
      ) : (
        <> </>
      )}
    </>
  );
};

export default AbaAditivos;
